import styled from 'styled-components'
import theme from 'live/services/theme'

export const Menu = styled.div`
    margin: unset;
    justify-content: unset;
    width: 100%;
    button {
        border: 0;
        margin-bottom: 4px;
        background: transparent !important;
        z-index: 281;
        position: relative;
        margin-top: -4px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            &.caret {
                margin: unset !important;
            }
        }
    }
    .dropdown-menu {
        top: -10px;
        z-index: 280;
        width: 100%;
    }

    li {
        > a {
            padding: 10px 18px !important;

            > div:nth-of-type(2) {
                display: flex;
                margin-top: 3px;

                a {
                    flex: 1;
                }
            }
        }
    }
`
export const Container = styled.div<{ isSimple: boolean }>`
    display: flex;
    width: 100%;
    min-height: ${props => (props.isSimple ? '50px' : '150px')};
    padding: 40px 0 0 0;
`
export const OptionsContainer = styled.div<{ isSimple: boolean }>`
    overflow-y: auto;
    min-width: 150px;
    max-height: 300px;
    width: 100%;
`

export const ItemContainer = styled.div<{ isSimple: boolean }>`
    display: flex;
    flex: 1;
    width: 100%;
    min-height: ${props => (props.isSimple ? '50px' : '100px')};
    flex-direction: column;
    justify-content: ${props => (props.isSimple ? 'center' : 'space-around')};
    padding: 5px 25px;
    border-bottom: 1px solid ${theme['input-borders']};
    text-transform: uppercase;

    &.selected {
        background: #e1f0ff;
    }
`
export const ItemHeader = styled.div`
    display: flex;
    align-items: center;
    height: 50%;
    width: 100%;
    justify-content: space-between;
    font-weight: 600;
`

export const ItemTitle = styled.div`
    font-size: 16;
    width: 100%;
    color: ${theme['dark-icons']};
`

export const ItemContent = styled.div`
    display: flex;
    height: 50%;
    align-items: center;
    justify-content: space-between;
    color: ${theme['gray']};
`

export const SubItemContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    color: ${theme['dark-icons']};
    font-size: 12px;
`
export const SubItemHeader = styled(ItemHeader)`
    font-size: 10px;
`

export const GraySelectorButton = styled.button`
    font-weight: 600;
    font-size: 14px;
    padding: 12px 12px;
    border-radius: 10px;
`

export const SelectorButtonDiv = styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 20;
    visibility: block;
    width: 127px;
    margin-right: 6px;
    border-radius: 10px;
`
